<template>
  <div>
    <h1>{{ $t("settings.role.mappingEdit") }}</h1>

    <div class="mt-3 elevation-12 grey lighten-4">
      <v-card>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field :label="$t('settings.role.wnbRoleName') + '*'" :rules="externalRole.nameRules" v-model="externalRole.name"></v-text-field>

            <v-data-table
              :headers="headers"
              :items="hasAuthItems"
              hide-default-footer
              :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
            >
              <template #item="props">
                <tr>
                  <td class="text-left">
                    {{ props.item.type == 2 ? $t("global.permission") : $t("global.role") }}
                  </td>
                  <td class="text-left">{{ props.item.translated_name }}</td>
                  <td class="text-left">{{ props.item.description }}</td>
                  <td class="text-left">
                    <v-tooltip bottom>
                      {{ $t("global.delete") }}
                      <template #activator="{on}">
                        <v-btn @click.native="removeAuthItem(props.item.name)" icon v-on="on">
                          <v-icon>clear</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert color="error" icon="warning">
                  {{ $t("settings.role.externalRoleNoPermissions") }}
                </v-alert>
              </template>
            </v-data-table>

            <v-row class="mt-5 md-2">
              <v-col
                ><h4>{{ $t("settings.role.addPermissions") }}</h4></v-col
              >
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
              </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="availableAuthItems" :search="search">
              <template #item="props">
                <tr>
                  <td class="text-left">
                    {{ props.item.type == 2 ? $t("global.permission") : $t("global.role") }}
                  </td>
                  <td class="text-left">{{ props.item.translated_name }}</td>
                  <td class="text-left">{{ props.item.description }}</td>
                  <td class="text-left">
                    <v-tooltip bottom>
                      {{ $t("global.add") }}
                      <template #activator="{on}">
                        <v-btn @click.native="addAuthItem(props.item.name)" icon v-on="on">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-form>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid" @click.native="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import roleMapping from "../../models/settings/roleMapping";

export default {
  name: "WnbRolesMappingForm",

  data: () => ({
    externalRole: new roleMapping(),
    allAuthItems: [],
    search: null,
    formValid: true
  }),
  created() {
    if (typeof this.$route.params.name !== "undefined") {
      this.externalRole.load(this.$route.params.name);
    }
    this.axios.get("settings/role-mapping/available-auth-items").then(resp => {
      this.allAuthItems = resp.data;
    });
  },
  computed: {
    headers() {
      return [
        { text: this.$t("global.type"), value: "type", width: "5%" },
        { text: this.$t("global.name"), value: "name", width: "10%" },
        {
          text: this.$t("global.description"),
          value: "description",
          width: "80%"
        },
        { text: this.$t("global.actions"), value: "actions", width: "5%" }
      ];
    },
    availableAuthItems() {
      const array = [];
      for (let authItem of this.allAuthItems.filter(this.filterAlreadyHaveItems)) {
        array.push(authItem);
      }
      return array;
    },

    hasAuthItems() {
      const array = [];
      for (let authItem of this.allAuthItems) {
        for (let externalAuthItem of this.externalRole.auth_items) {
          if (externalAuthItem === authItem.name) {
            array.push(authItem);
          }
        }
      }
      return array;
    }
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.externalRole
          .save()
          .then(() => {
            this.$router.push({ path: "/settings/role/mapping" });
          })
          .catch(response => {
            this.$store.dispatch("alertDialog", {
              content: this.$t("global.error.generalError.content") + response,
              title: this.$t("global.error.generalError.title")
            });
          });
      }
    },
    addAuthItem(authItemName) {
      this.externalRole.auth_items.push(authItemName);
    },
    removeAuthItem(authItemName) {
      this.externalRole.auth_items.splice(this.externalRole.auth_items.indexOf(authItemName), 1);
    },
    filterAlreadyHaveItems(item) {
      for (let userAuthItem of this.externalRole.auth_items) {
        if (userAuthItem === item.name) {
          return false;
        }
      }
      return true;
    },
    cancel() {
      this.$router.push("/settings/role/mapping");
    }
  }
};
</script>

<style scoped></style>
